import { type FC } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { CancelButton, EditButton } from "@/shared/Components/Buttons";
import { useContactsControlButtons } from "../../model/hooks/use-contacts-control-buttons";
import { DeleteContactButton } from "../../Tabs/GeneralInfoTab/Components/DeleteContactButton";
import styles from "./styles.module.scss";

type Props = {
  tabType?: "generalInfo" | "activities";
  className?: string;
};

export const ControlButtons: FC<Props> = ({ tabType, className }) => {
  const { t } = useTranslation();

  const { cancelHandler, editHandler, isEdit } = useContactsControlButtons({
    tabType,
  });
  if (isEdit) {
    return (
      <>
        <div className={classNames(styles["buttons-group"], className)}>
          <CancelButton className={styles.button} onClick={cancelHandler}>
            {t("common.cancel")}
          </CancelButton>
          <DeleteContactButton />
        </div>
      </>
    );
  }
  return (
    <>
      <div className={styles["buttons-group"]}>
        <DeleteContactButton />
        <EditButton className={styles.button} onClick={editHandler}>
          {t("common.edit")}
        </EditButton>
      </div>
    </>
  );
};
